<div class="page-header ">
  <div class="flex xl:align-items-center flex-wrap xl:flex-nowrap gap-3 w-full">
    <div class="flex-grow-1">
      <app-primeng-breadcrumb ></app-primeng-breadcrumb>
    </div>
      <div class="right-container flex flex-wrap xl:flex-nowrap gap-3 justify-content-end">
          <!-- <p-button label="Add User" (onClick)="addUserModal()" icon="ti ti-plus" resourceName="USER" permission="EDIT" permissions [outlined]="false" severity="primary" /> -->
      <p-button *ngIf="isEditPermission" label="Add User" (onClick)="addUserModal()" [outlined]="false" severity="primary" >
        <i-tabler class="ti-normal ti-lg" name="plus"></i-tabler>
      </p-button>
      </div>
  </div>
</div>

<div class="page-content"  >
  <app-skeleton *ngIf="loading" id="table-items" [columns]="tableConfig" [paginator]="true"></app-skeleton>
  <div *ngIf="!loading" class="table-responsive" permissions resourceName="USER" permission="READ">
    <app-users-list  [isCustomer]="isCustomer" [tableData]="tableData" [tableConfig]="tableConfig" [isEditPermission]="isEditPermission">
    </app-users-list>
  </div>
</div>

<p-toast />